module.exports = __webpack_public_path__ + "img/img2.aa8c1773.jpg";